import { combineReducers } from "redux";

import { addonsCategoryDetails } from "./reducer.addonCategory"
const agentAddonsCategoryReducers = combineReducers({

    addonsCategoryDetails

})
export default agentAddonsCategoryReducers;
